// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Uc-z","innerTile":"Vc-z","heading":"Wc-z","instaTileBtn":"Xc-z","disabled":"Yc-z","instaTileElement":"Zc-z","instagramPic":"_c-z"};